export default "__VITE_ASSET__BFgyH6XK__"